<template>
  <div class="introduce_page">
    <img src="http://app.qcql.cn/img/img1.jpg" class="introduce_img"/>
    <img src="http://app.qcql.cn/img/img1_1.jpg" class="introduce_img"/>
    
    <div class="introduce_wrap">
      <!-- <a href="http://app.qcql.cn/pdf/胎温胎压传感器.pdf" target="_blank" class="introduce_wrap_item"> -->
      <a href="http://app.qcql.cn/img/胎温胎压监测.jpg" target="_blank" class="introduce_wrap_item">
        <img src="http://app.qcql.cn/img/assets/icon1.jpg"/>
        <div>胎温胎压监测</div>
      </a>
      <!-- <a href="http://app.qcql.cn/pdf/轴温传感器.pdf" target="_blank" class="introduce_wrap_item"> -->
      <a href="http://app.qcql.cn/img/轴温监测.jpg" target="_blank" class="introduce_wrap_item">
        <img src="http://app.qcql.cn/img/assets/icon2.jpg"/>
        <div>轴温监测</div>
      </a>
      <!-- <a href="http://app.qcql.cn/pdf/自动喷淋.pdf" target="_blank" class="introduce_wrap_item"> -->
      <a href="http://app.qcql.cn/img/自动喷淋.jpg" target="_blank" class="introduce_wrap_item">
        <img src="http://app.qcql.cn/img/assets/icon3.jpg"/>
        <div>自动喷淋</div>
      </a>
      <!-- <a href="http://app.qcql.cn/pdf/网关控制器.pdf" target="_blank" class="introduce_wrap_item"> -->
      <a href="http://app.qcql.cn/img/网关控制器.jpg" target="_blank" class="introduce_wrap_item">
        <img src="http://app.qcql.cn/img/assets/icon4.jpg"/>
        <div>网关/控制器</div>
      </a>
      <a href="#img3" class="introduce_wrap_item">
        <img src="http://app.qcql.cn/img/assets/icon5.jpg"/>
        <div>智能甩挂</div>
      </a>
      <a href="#img4" class="introduce_wrap_item">
        <img src="http://app.qcql.cn/img/assets/icon6.jpg"/>
        <div>轨迹回放、里程管理</div>
      </a>
      <a href="#img5" class="introduce_wrap_item">
        <img src="http://app.qcql.cn/img/assets/icon7.jpg"/>
        <div>电子围栏</div>
      </a>
      <a href="#img6" class="introduce_wrap_item">
        <img src="http://app.qcql.cn/img/assets/icon8.jpg"/>
        <div>服务及过程跟踪</div>
      </a>
      <a href="#img7" class="introduce_wrap_item">
        <img src="http://app.qcql.cn/img/assets/icon9.jpg"/>
        <div>车队可视管理</div>
      </a>
      <img src="http://app.qcql.cn/img/img2.jpg" class="introduce_img"/>
      <img id="img3" src="http://app.qcql.cn/img/img3.jpg" class="introduce_img"/>
      <img id="img4" src="http://app.qcql.cn/img/img4.jpg" class="introduce_img"/>
      <img id="img5" src="http://app.qcql.cn/img/img5.jpg" class="introduce_img"/>
      <img id="img6" src="http://app.qcql.cn/img/img6.jpg" class="introduce_img"/>
      <img id="img7" src="http://app.qcql.cn/img/img7.jpg" class="introduce_img"/>
      <img src="http://app.qcql.cn/img/img8.jpg" class="introduce_img"/>
      <img src="http://app.qcql.cn/img/img9.jpg" class="introduce_img"/>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
    };
  },
  created() {
  },
  mounted(){
  },
  methods: {
  }
}
</script>
<style scoped>
.introduce_img{
  width: 100%;
  height: auto;
}
.introduce_page1 {
  height: 100%;
  width: 100%;
  position: absolute;
  background: url("../assets/back.jpg");
  background-size: 80%;
  /* padding: 10px; */
}
.introduce_icon{
  width: 60%;
  display: block;
  margin: 50px auto;
}
.introduce_wrap{
  display: flex;
  flex-wrap: wrap;
  padding: 5px;
}
.introduce_wrap_item{
  width: calc(33.3vw - 14px);
  height: calc(33.33vw - 10px);
  margin: 5px;
  position: relative;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0px 0px 10px 2px #CCCCCC;
}
.introduce_wrap_item img{
  width: 100%;
  height: auto;
}
.introduce_wrap_item div{
  position: absolute;
  bottom: 10px;
  left: 0px;
  padding: 0 5px;
  display: -webkit-box;
  -webkit-box-orient: vertical; 
  -webkit-line-clamp: 1; 
  overflow: hidden;
  text-align: center;
  width: 100%;
  color: #4d70ff;
  box-sizing: border-box;
  text-decoration: underline;
  font-size: 13px;
}
.introduce_wrap_item:visited div{
  color: #4007a2;
}
</style>



// WEBPACK FOOTER //
// src/components/introduce.vue